import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { AnalyticsQueryDashboard, BidMetricsByBidder, MappedName } from '@pubstack/common/src/analytics/query'
import { useAtomValue } from 'jotai'
import { FunctionComponent } from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { AnalyticsPage } from '~/modules/analytics/AnalyticsPage'
import { contextState } from '~/state'
import { PureBiddersOverview } from './PureBiddersOverview'

const DIMENSIONS: Dimension[] = ['tagId', 'bidder', 'adUnit', 'device', 'country', 'size', 'pubstackRefresh', 'stackIdVersion']
const DASHBOARD: AnalyticsQueryDashboard = { name: 'bidders', filterType: 'auctions' }

export const BiddersOverview: FunctionComponent = () => {
  const navigate = useNavigate()

  const context = useAtomValue(contextState)
  const analyticsQuery = useAnalyticsQueryTanstack<BidMetricsByBidder>('bid.metrics.by.bidder', DIMENSIONS, context, {})
  const currencySymbol = useScopeCurrency()
  const breadcrumbs = useBreadcrumbs()
  const [showMinorData] = useLocalStorage({ key: 'showMinorData', defaultValue: false })
  const threshold = showMinorData ? 0 : undefined
  const maxNumberOfDayInTimerangeSelected = 31

  const onRefreshClick = () => {
    return
  }

  const onRowClick = (bidderName: MappedName) => {
    navigate({
      pathname: `/analytics/bidders/${bidderName.label}`,
      search: `?${createSearchParams({
        from: context.timeRange.from.toFormat('yyyy-MM-dd'),
        to: context.timeRange.to.toFormat('yyyy-MM-dd'),
        mapping: btoa(
          JSON.stringify({
            bidder: bidderName.value,
            bidderName: bidderName.label,
          })
        ),
      })}`,
    })
  }

  return (
    <AnalyticsPage
      onRefreshClick={onRefreshClick}
      filterDimensions={DIMENSIONS}
      dashboard={DASHBOARD}
      title={breadcrumbs}
      maxNumberOfDayInTimerangeSelected={maxNumberOfDayInTimerangeSelected}
      showMinorDataToggle={true}
    >
      <PureBiddersOverview
        isLoading={analyticsQuery.isFetching}
        error={analyticsQuery.isError}
        empty={!analyticsQuery.isLoading && !analyticsQuery?.data?.name?.length}
        onRefreshClick={onRefreshClick}
        rawData={analyticsQuery.data}
        currencySymbol={currencySymbol}
        onRowClick={onRowClick}
        onSortChange={() => {}}
        displayableBidRequestsPercentageThreshold={threshold}
        displayableImpressionRevenuePercentageThreshold={threshold}
      />
    </AnalyticsPage>
  )
}
